import { useCart } from "@shopify/hydrogen";
import { header } from "../../../../setup/settings/__home";

export default function CartBadge({ }) {
  const { totalQuantity } = useCart();

  if (totalQuantity < 1) {
    return null;
  }

  if (header.cartCounter)
    return (
      <div className='topUserArea__numberProducts absolute subpixel-antialiased flex items-center justify-center leading-none'>
        <span>{totalQuantity}</span>
      </div>
    );
  else return (
    <div className='topUserArea__dotProducts absolute subpixel-antialiased flex items-center justify-center leading-none'>
      <span className="dot rounded-full" />
    </div>
  )
}